<div class="colors">
    <button class="round-action-button color-picker-button" mat-icon-button (click)="openColorPicker()" #colorPickerButton>
        <svg-icon name="color-wheel-custom"></svg-icon>
    </button>
    <button
            class="no-style color control"
            (click)="changeColor(color)"
            *ngFor="let color of colors"
            [style.background]="color"
            [class.selected]="selectedColor === color"
    ></button>
</div>
<div class="bottom-label" trans><ng-content></ng-content></div>